import { render, staticRenderFns } from "./TraceManage.vue?vue&type=template&id=0fa4b842&scoped=true"
import script from "./TraceManage.vue?vue&type=script&lang=js"
export * from "./TraceManage.vue?vue&type=script&lang=js"
import style0 from "./TraceManage.vue?vue&type=style&index=0&id=0fa4b842&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fa4b842",
  null
  
)

export default component.exports